import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "modal",
        "heroName",
        "heroName2",
        "image",
        "imageFallback",
        "imageDownload",
        "copyAnswerButton",
        "answer"
    ]

    open(event) {
        const button = event.currentTarget

        this.name = (button.dataset.name || "Hero").trim()
        this.answer = (button.dataset.answer || "No response available.").trim()
        this.imageUrl = button.dataset.imageUrl || ""
        this.storyUrl = button.dataset.storyUrl || ""

        const possessiveName = this.possessive(this.name)

        if (this.hasHeroNameTarget) {
            this.heroNameTarget.textContent = possessiveName
        }

        if (this.hasHeroName2Target) {
            this.heroName2Target.textContent = this.name
        }

        this.answerTarget.textContent = this.answer
        if (this.hasCopyAnswerButtonTarget) {
            this.copyAnswerButtonTarget.dataset.clipboardText = this.answer
        }

        // this.fullSharePackButtonTarget.dataset.clipboardText = fullSharePack

        if (this.imageUrl.length > 0) {
            this.imageTarget.src = this.imageUrl
            this.imageTarget.alt = `${this.possessive(this.name)} photo`
            this.imageTarget.classList.remove("hidden")

            this.imageFallbackTarget.classList.add("hidden")
            this.imageDownloadTarget.classList.remove("pointer-events-none", "opacity-50")
        } else {
            this.imageTarget.removeAttribute("src")
            this.imageTarget.alt = ""
            this.imageTarget.classList.add("hidden")

            this.imageFallbackTarget.classList.remove("hidden")
            this.imageDownloadTarget.classList.add("pointer-events-none", "opacity-50")
        }

        this.modalTarget.classList.remove("hidden")
        document.body.classList.add("overflow-hidden")
    }

    close() {
        this.modalTarget.classList.add("hidden")
        document.body.classList.remove("overflow-hidden")
    }

    async downloadImage(event) {
        event.preventDefault()

        if (!this.imageUrl) return

        const filename = `${this.parameterize(this.name)}-photo.jpg`

        try {
            const response = await fetch(this.imageUrl, { mode: "cors" })
            if (!response.ok) throw new Error(`HTTP ${response.status}`)

            const blob = await response.blob()
            const blobUrl = window.URL.createObjectURL(blob)

            const link = document.createElement("a")
            link.href = blobUrl
            link.download = filename
            document.body.appendChild(link)
            link.click()
            link.remove()

            window.setTimeout(() => {
                window.URL.revokeObjectURL(blobUrl)
            }, 1000)
        } catch (error) {
            window.open(this.imageUrl, "_blank", "noopener")
        }
    }

    possessive(name) {
        if (!name) return "Hero’s"
        return name.toLowerCase().endsWith("s") ? `${name}’` : `${name}’s`
    }

    parameterize(value) {
        return value
            .toLowerCase()
            .trim()
            .replace(/['"]/g, "")
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "")
    }
}
